export type PresentationTypeInititals = 'RAR' | 'RGRL' | 'SVCC';


export const HABILITATION_TITLE_VALID_OPTIONS = [
    'LIC.SEGHIG',
    'TEC.SEGHIG',
    'TEC.SAN AMB',
    'INGENIERO',
    'MEDICO',
    'ESP.MED.TRAB',
    'OTROS'
] as const;

export const CUSTOM_HABILITATION_TITLE_OPTION = 'OTROS';

export const isExisitingHabilitationTitle = (value: string) => {
    return HABILITATION_TITLE_VALID_OPTIONS.slice(0, -1).includes(value as any);
};